var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgrInspectionSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6413 19.6304C13.2554 19.6304 12.0774 19.1454 11.1073 18.1753C10.1372 17.2052 9.65217 16.0272 9.65217 14.6413C9.65217 13.2554 10.1372 12.0774 11.1073 11.1073C12.0774 10.1372 13.2554 9.65217 14.6413 9.65217C16.0272 9.65217 17.2052 10.1372 18.1753 11.1073C19.1454 12.0774 19.6304 13.2554 19.6304 14.6413C19.6304 16.0272 19.1454 17.2052 18.1753 18.1753C17.2052 19.1454 16.0272 19.6304 14.6413 19.6304ZM14.6413 17.9674C15.556 17.9674 16.339 17.6417 16.9904 16.9904C17.6417 16.339 17.9674 15.556 17.9674 14.6413C17.9674 13.7266 17.6417 12.9436 16.9904 12.2923C16.339 11.6409 15.556 11.3152 14.6413 11.3152C13.7266 11.3152 12.9436 11.6409 12.2923 12.2923C11.6409 12.9436 11.3152 13.7266 11.3152 14.6413C11.3152 15.556 11.6409 16.339 12.2923 16.9904C12.9436 17.6417 13.7266 17.9674 14.6413 17.9674ZM4.66304 17.9674C4.20571 17.9674 3.8142 17.8046 3.48852 17.4789C3.16284 17.1532 3 16.7617 3 16.3043V9.98478C3 9.87391 3.01039 9.76304 3.03118 9.65217C3.05197 9.5413 3.08315 9.43043 3.12473 9.31956L4.78777 5.49457H4.66304C4.42745 5.49457 4.22996 5.41488 4.07058 5.2555C3.91121 5.09613 3.83152 4.89864 3.83152 4.66304V3.83152C3.83152 3.59592 3.91121 3.39844 4.07058 3.23906C4.22996 3.07969 4.42745 3 4.66304 3H10.4837C10.7193 3 10.9168 3.07969 11.0762 3.23906C11.2355 3.39844 11.3152 3.59592 11.3152 3.83152V4.66304C11.3152 4.89864 11.2355 5.09613 11.0762 5.2555C10.9168 5.41488 10.7193 5.49457 10.4837 5.49457H10.359L11.731 8.65435C11.4677 8.79294 11.2182 8.93845 10.9826 9.0909C10.747 9.24334 10.5253 9.41658 10.3174 9.6106L8.5712 5.49457H6.57554L4.66304 9.98478V16.3043H8.19701C8.2663 16.5954 8.35985 16.8829 8.47765 17.1671C8.59545 17.4512 8.7375 17.7179 8.9038 17.9674H4.66304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15.4728H18.7989V13.8098H21V15.4728Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8098 21V18.7989H15.4728V21H13.8098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8098 10.4837V8.28261H15.4728V10.4837H13.8098Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3152 15.4728H8.47765V13.8098H11.3152V15.4728Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6413 15.4728C15.1005 15.4728 15.4728 15.1005 15.4728 14.6413C15.4728 14.1821 15.1005 13.8098 14.6413 13.8098C14.1821 13.8098 13.8098 14.1821 13.8098 14.6413C13.8098 15.1005 14.1821 15.4728 14.6413 15.4728ZM14.6413 16.3043C15.5598 16.3043 16.3043 15.5598 16.3043 14.6413C16.3043 13.7228 15.5598 12.9783 14.6413 12.9783C13.7228 12.9783 12.9783 13.7228 12.9783 14.6413C12.9783 15.5598 13.7228 16.3043 14.6413 16.3043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgrInspectionSystem);
export default __webpack_public_path__ + "static/media/AGRInspectionSystem.23432ddfc63f516858819d2bad7f3ed5.svg";
export { ForwardRef as ReactComponent };